import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import { init18next } from './i18n/config';
import { App } from './app/App';

const render = async () => {
  await init18next();
  const container = document.getElementById('root');
  if (container) {
    if (container.hasChildNodes()) {
      hydrateRoot(container, <App />);
    } else {
      const root = createRoot(container);
      root.render(<App />);
    }
  }
};

render();
